import React from "react";
import styles from "./Modal.module.css";

const Modal = ({ isOpen, children, setIsOpen }) => {
  if (isOpen)
    return (
      <div
        className={styles.modal_container}
        // onClick={(e) => {
        //   if (e.target === e.currentTarget) {
        //     setIsOpen(!isOpen);
        //   }
        // }}
      >
        <div className={`${styles.modal}`}>{children}</div>
      </div>
    );
};

export default Modal;
